import HomePage from 'pages/Home';
import useSettings from 'store/settings';

import SportPage from 'pages/Sport';
import useAnalytics from 'hooks/useAnalytics';
import useMount from 'hooks/useMount';
import { AnalyticsKey, AnalyticsPageViewEvents } from 'hooks/useAnalytics/enum';

const Main = () => {
  const [settings] = useSettings();
  const { sendEvent } = useAnalytics();

  useMount(() => {
    sendEvent({
      [AnalyticsKey.pageView]: AnalyticsPageViewEvents.homePageView,
    });
  });

  if (settings?.data?.meta?.isHomepageActive) {
    return <HomePage />;
  }

  return <SportPage />;
};

export default Main;
